import { Checkbox } from "@mui/material";
import ImgBackgroundModal from "../../../../../common/components/ImgBackgroundModal";
import { useEffect, useState } from "react";

const ReviewAndConfirmModal = ({
  show,
  btnActtion,
}: {
  show?: number;
  btnActtion: () => void;
}) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (show) {
      setShowModal(true);
    }
  }, [show]);

  return (
    <ImgBackgroundModal
      showModal={showModal}
      headerText="Review & Confirm Before You Proceed"
      subTextDiv={
        <div className="text-[#363636] font-light pt-[10px] pb-[10px]">
          For more information or enquiries reach out to us on{" "}
          <a
            href="#fff"
            className="text-[#066D0E] underline hover:no-underline"
          >
            info@homeandabroad.ng
          </a>{" "}
          or{" "}
          <a
            href="#fff"
            className="text-[#066D0E] underline hover:no-underline"
          >
            call us on...
          </a>{" "}
        </div>
      }
      btnActtion={btnActtion}
      onCloseModal={() => setShowModal(false)}
    >
      <div>
        <div className="text-[16px] text-[#5E5E5E] font-light mb-[10px] flex flex-col gap-[20px]">
          <span>
            Congratulations, You are One click away from completing your
            Property Purchase on Home and Abroad. We are happy you have trusted
            us on the Journey thus far!
          </span>
          <span>
            Upon completion of this process, You will receive a property sales
            receipt from the platform, we will also begin the preparation of the
            following property documents which will be available for download:
          </span>
          <ol className="list-decimal pl-5 space-y-[15px]">
            <li>Property Developer Sales Receipt</li>
            <li>Letter of Allotment (Houses)</li>
            <li>Letter of Allocation (Land)</li>
            <li>Title Deed (Houses)</li>
          </ol>
          <span>
            These documents will be made available to you for your review
            between 1-5 Business Days. Hard copies of all the official documents
            to the Property and Property keys will be sent to (Customers
            Address) Via DHL expected date of arrival will be communicated
            to you via email.
          </span>

          <span>
            Sit Back and Relax while we complete your home acquisition process
            for you.
          </span>
        </div>
      </div>
    </ImgBackgroundModal>
  );
};

export default ReviewAndConfirmModal;
